import React from 'react';

function YDVerify(props: any) {
  let captchaIns: any;
  const initNECaptchaWithFallback = (window as any).initNECaptchaWithFallback;
  initNECaptchaWithFallback(
    {
      element: '#ydn',
      captchaId: '3f51517b1c3343bcaabd750d302eae90d28d',
      width: '276px',
      mode: 'float',
      apiVersion: 2,
      onVerify: function (err: any, data: any) {
        /**
         * 第一个参数是err（Error的实例），验证失败才有err对象
         * 第二个参数是data对象，验证成功后的相关信息，data数据结构为key-value，如下：
         * {
         *   validate: 'xxxxx' // 二次验证信息
         * }
         **/
        if (err) return; // 当验证失败时，内部会自动refresh方法，无需手动再调用一次

        // 点击登录按钮后可调用服务端接口，以下为伪代码，仅作示例用
        console.log(data);
      }
    },
    function onload(instance: any) {
      captchaIns = instance;
      console.log(captchaIns);
    },
    function onerror(err: any) {
      console.warn(err);
    }
  );
  return (
    <div className="login_layout__title">
      <div id="ydn"></div>
    </div>
  );
}

export default YDVerify;
